<template>
  <transition name="FadeIn">
    <div
      class="Popup Politics"
      v-if="forms.contractPopup.opened"
      @click.self="managePopupState({ popup: 'contractPopup', _state: false })"
    >
      <div class="Politics__inner">
        <div
          class="Popup__close"
          @click="managePopupState({ popup: 'contractPopup', _state: false })"
        >
          <span aria-label="Close Popup">&times;</span>
        </div>
        <div class="Politics__content">
          <div class="Politics__caption">
            <h3>{{ $t("PUBLIC_CONTRACT.TITLE") }}</h3>
          </div>
          <p>{{ $t("PUBLIC_CONTRACT.TEXT_1") }}</p>
          <ol class="Politics__list">
            <li>{{ $t("PUBLIC_CONTRACT.LIST.1") }}</li>
            <li>{{ $t("PUBLIC_CONTRACT.LIST.2") }}</li>
            <li>{{ $t("PUBLIC_CONTRACT.LIST.3") }}</li>
            <li>{{ $t("PUBLIC_CONTRACT.LIST.4") }}</li>
          </ol>
          <p>{{ $t("PUBLIC_CONTRACT.TEXT_2") }}</p>
          <p style="margin: 30px 0 0 0">
            <strong>Директор:</strong
            ><span style="margin: 0 0 0 20px">Қорданова Г.</span>
          </p>
          <p><strong>Общественный фонд "Teach for Kazakhstan"</strong></p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Contract",
  methods: {
    ...mapMutations(["managePopupState"])
  },
  computed: {
    ...mapGetters(["forms"])
  }
};
</script>
